<template>
    <div id="product-details">
        <div class="product-container" v-if="getProduct" :class="productImpressionTracking()">
            <div class="left">
                <div class="holder">
                    <div class="tags" v-if="getProduct.Tags">
                        <div class="tag" v-for="(tag,index) in getProduct.Tags" :class="tag.ColourClass">
                            <p>
                                <span :class="{small: tag.Subtitle}">{{ tag.Title }}</span>
                                <span class="large" v-if="tag.Subtitle">{{ tag.Subtitle }}</span>
                            </p>
                        </div>
                    </div>
                    <vue-glide :perView="1" type="carousel" v-if="getProduct.ProductImages">
                        <vue-glide-slide v-for="(image,index) in getProduct.ProductImages" :key="index">
                            <img :src="image.URL">
                        </vue-glide-slide>
                        <template slot="control" v-if="getProduct.ProductImages.length > 1">
                            <button data-glide-dir="<"><i class="fal fa-long-arrow-left"></i></button>
                            <button data-glide-dir=">"><i class="fal fa-long-arrow-right"></i></button>
                        </template>
                    </vue-glide>
                </div>
            </div>
            <div class="right">
                <div class="holder">
                    <p class="model" v-if="getProduct.Model">{{ getProduct.Model }}</p>
                    <h1>{{ getProduct.Title }}</h1>
                    <div class="description" v-if="getProduct.Description" v-html="getProduct.Description"></div>
                    <div v-if="getProduct.ProductType === 'EventProduct'" class="description">
                        <p v-if="getProduct.Location"><span class="bold">Location:</span> {{ getProduct.Location }}</p>
                        <p v-if="getProduct.StartTime"><span class="bold">Starts at:</span> {{ getProduct.StartTime | date }}</p>
                        <p v-if="getProduct.EndTime"><span class="bold">Finishes at:</span> {{ getProduct.EndTime | date }}</p>
                    </div>
                    <div class="purchase">
                        <div class="prices" v-if="getProduct.LocalisedPrice > 0 || getProduct.ProductType === 'EventProduct'">
                            <div v-if="getProduct.ProductType === 'EventProduct'">
                                <div v-if="getProduct.ExternalBookingLink">

                                </div>
                                <div v-else-if="getProduct.LocalisedPrice > 0">
                                    <p class="price" :class="{slashed: getProduct.DiscountedPrice !== getProduct.LocalisedPrice}">
                                        ${{ getProduct.LocalisedPrice.toFixed(2) }} <span>{{ getProduct.Currency }}</span></p>
                                    <p class="price" v-if="getProduct.DiscountedPrice !== getProduct.LocalisedPrice">
                                        ${{ getProduct.DiscountedPrice.toFixed(2) }} <span>{{ getProduct.Currency }}</span></p>
                                </div>
                                <div v-else>
                                    <p class="price">Free Event</p>
                                </div>
                            </div>
                            <div v-else>
                                <div v-if="productAttribute('LocalisedPrice') > 0">
                                    <span class="price-from" v-if="getProduct.Variations.length">From </span>
                                    <p class="price" :class="{slashed: productAttribute('DiscountedPrice') !== productAttribute('LocalisedPrice')}">
                                        ${{ productAttribute('LocalisedPrice').toFixed(2) }} <span>{{ getProduct.Currency }}</span></p>
                                    <p class="price" v-if="productAttribute('DiscountedPrice') !== productAttribute('LocalisedPrice')">
                                        ${{ productAttribute('DiscountedPrice').toFixed(2) }} <span>{{ getProduct.Currency }}</span></p>
                                </div>
                            </div>

                            <div class="variations" v-if="getProduct.Variations.length">
                                <v-select id="product-variation"
                                          v-model="selectedVariationID"
                                          :options="getProduct.Variations"
                                          :reduce="variation => variation.ID"
                                          label="Title"
                                          :clearable="false"
                                          placeholder="Please choose from available options">
                                </v-select>
                            </div>
                        </div>

                        <div class="quantity">
                            <AddToCart v-if="productAttribute('LocalisedPrice') > 0 || getProduct.VariableAmount"
                                       :product="getProduct"
                                       :variation="selectedVariation"
                                       :isButton="true"
                                       buttonText="Add to Cart"
                                       extraClasses="btn-dark"
                                       :showQuantity="true"
                                       :showExpressOption="getProduct.ExpressCheckout > 0"/>
                            <template v-if="getProduct.ProductType === 'EventProduct'">
                                <a v-if="getProduct.ExternalBookingLink" class="btn btn-dark shadow-light" target="_blank"
                                   :href="getProduct.ExternalBookingLink">Book Now</a>
                                <template v-else-if="getProduct.RequireRSVP">
                                    <p v-if="getEventBooked">Booked, We look forward to seeing you.</p>
                                    <button v-else class="btn btn-dark shadow-light" @click="showRSVPForm = true">RSVP</button>
                                </template>
                            </template>
                        </div>
                    </div>
                    <div class="actions share">

                        <div class="add-to-cart social-share">
                            <template v-if="firstLoad">
                                <div v-if="getProduct.IsAddedInWishList == true" class="link" @click="updateWish(getProduct.RemoveWishlistLink)">
                                    <i class="fal fa-heart" aria-hidden="true"></i>
                                    <span>Added in Wishlist</span>
                                </div>
                                <div v-else class="link aa" @click="updateWish(getProduct.AddWishlistLink)">
                                    <i class="fal fa-heart" aria-hidden="true"></i>
                                    <span>Add to Wishlist</span>
                                </div>
                            </template>
                            <template v-else>
                                <div v-if="IsAddedInWishList == true" class="link" @click="updateWish(getProduct.RemoveWishlistLink)">
                                    <i class="fal fa-heart" aria-hidden="true"></i>
                                    <span>Added in Wishlist</span>
                                </div>
                                <div v-else class="link bb " @click="updateWish(getProduct.AddWishlistLink)">
                                    <i class="fal fa-heart" aria-hidden="true"></i>
                                    <span>Add to Wishlist</span>
                                </div>
                            </template>
                        </div>

                        <div class="add-to-cart social-share">
                            <div class="link" v-on:click="showShareLinks = !showShareLinks">
                                <i class="fal fa-share-alt" aria-hidden="true"></i>
                                <span>Share</span>
                            </div>

                            <div class="social-shares" v-bind:class="{'show': showShareLinks}">
                                <div class="item">
                                    <a target="_blank"
                                       :href="`//www.pinterest.com/pin/create/button/?url=${getProduct.Link}&media=${getProduct.Image.URL}&description=Next%20stop%3A%20Pinterest`">
                                        <i class="fab fa-pinterest"></i>
                                    </a>
                                </div>
                                <div class="item">
                                    <a :href="`https://www.facebook.com/sharer/sharer.php?u=${getProduct.Link}`" target="_blank">
                                        <i class="fab fa-facebook-f"></i>
                                    </a>
                                </div>
                                <div class="item">
                                    <a :href="`https://twitter.com/intent/tweet?text=${getProduct.Title}&url=${getProduct.Link}`" target="_blank">
                                        <i class="fab fa-twitter"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="add-to-cart social-share">
                            <div v-if="getProduct.TastingNotes && getProduct.TastingNotes.ID !== 0" class="link aa"
                                 @click="openNewTab(getProduct.TastingNotes.URL)">
                                <i class="fal fa-file-download" aria-hidden="true"></i>
                                <span>Download Tasting Notes</span>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <p class="accordion-toggle" v-b-toggle.product-description v-if="getProduct.Summary">
                        Description
                        <span class="when-opened"><i class="fa fa-chevron-down" aria-hidden="true"></i></span>
                        <span class="when-closed"><i class="fa fa-chevron-up" aria-hidden="true"></i></span>
                    </p>
                    <b-collapse class="accordion-body" id="product-description" v-if="getProduct.Summary">
                        <div v-html="getProduct.Summary"></div>
                    </b-collapse>
                    <hr v-if="getProduct.Summary">
                    <p class="accordion-toggle" v-b-toggle.product-analysis v-if="showStats()">
                        Technical Analysis
                        <span class="when-opened"><i class="fa fa-chevron-down" aria-hidden="true"></i></span>
                        <span class="when-closed"><i class="fa fa-chevron-up" aria-hidden="true"></i></span>
                    </p>
                    <b-collapse class="accordion-body" id="product-analysis" v-if="showStats()">
                        <div class="items">

                            <div class="item" v-if="showHarvestStats()">
                                Harvest
                                <hr>
                            </div>
                            <div class="item" v-if="showWineStats()">
                                Wine
                                <hr>
                            </div>

                            <template v-if="getProduct.HarvestDate || getProduct.Alcohol">
                                <div class="item">
                                    <label>Harvest Date</label>
                                    <p>{{ getProduct.HarvestDate }}&nbsp;</p>
                                    <hr>
                                </div>
                                <div class="item">
                                    <label>Alcohol</label>
                                    <p>{{ getProduct.Alcohol }}&nbsp;</p>
                                    <hr>
                                </div>
                            </template>

                            <template v-if="getProduct.Brix || getProduct.ResidualSugar">
                                <div class="item">
                                    <label>Brix</label>
                                    <p>{{ getProduct.Brix }}&nbsp;</p>
                                    <hr>
                                </div>
                                <div class="item">
                                    <label>Residual Sugar</label>
                                    <p>{{ getProduct.ResidualSugar }}&nbsp;</p>
                                    <hr>
                                </div>
                            </template>
                            <template v-if="getProduct.HarvestAcidity || getProduct.WineAcidity">
                                <div class="item">
                                    <label>Titratable Acidity</label>
                                    <p>{{ getProduct.HarvestAcidity }}&nbsp;</p>
                                    <hr>
                                </div>
                                <div class="item">
                                    <label>Titratable Acidity</label>
                                    <p>{{ getProduct.WineAcidity }}&nbsp;</p>
                                    <hr>
                                </div>
                            </template>
                            <template v-if="getProduct.HarvestPhValue || getProduct.WinePhValue">
                                <div class="item">
                                    <label>PH</label>
                                    <p>{{ getProduct.HarvestPhValue }}&nbsp;</p>
                                    <hr>
                                </div>
                                <div class="item">
                                    <label>PH</label>
                                    <p>{{ getProduct.WinePhValue }}&nbsp;</p>
                                    <hr>
                                </div>
                            </template>
                            <template v-if="getProduct.Vineyard || getProduct.Blend">
                                <div class="item">
                                    <label>Vineyard</label>
                                    <p>{{ getProduct.Vineyard }}&nbsp;</p>
                                </div>
                                <div class="item">
                                    <label>Variety</label>
                                    <p>{{ getProduct.Blend }}&nbsp;</p>
                                </div>
                            </template>
                        </div>
                    </b-collapse>
                    <hr v-if="getProduct.Alcohol">
                    <p class="accordion-toggle" v-b-toggle.product-cellar v-if="getProduct.Cellaring">
                        Cellaring
                        <span class="when-opened"><i class="fa fa-chevron-down" aria-hidden="true"></i></span>
                        <span class="when-closed"><i class="fa fa-chevron-up" aria-hidden="true"></i></span>
                    </p>
                    <b-collapse class="accordion-body" id="product-cellar" v-html="getProduct.Cellaring" v-if="getProduct.Cellaring"></b-collapse>
                    <hr v-if="getProduct.Cellaring">
                    <p class="accordion-toggle" v-b-toggle.product-food v-if="getProduct.FoodMatch">
                        Food Matches
                        <span class="when-opened"><i class="fa fa-chevron-down" aria-hidden="true"></i></span>
                        <span class="when-closed"><i class="fa fa-chevron-up" aria-hidden="true"></i></span>
                    </p>
                    <b-collapse class="accordion-body" id="product-food" v-html="getProduct.FoodMatch" v-if="getProduct.FoodMatch"></b-collapse>
                    <hr v-if="getProduct.FoodMatch">
                    <p class="accordion-toggle" v-b-toggle.product-accolades v-if="getProduct.Accolades">
                        Accolades
                        <span class="when-opened"><i class="fa fa-chevron-down" aria-hidden="true"></i></span>
                        <span class="when-closed"><i class="fa fa-chevron-up" aria-hidden="true"></i></span>
                    </p>
                    <b-collapse class="accordion-body" id="product-accolades" v-if="getProduct.Accolades">
                        <div v-for="(Accolade, index) in getProduct.Accolades" :key="index">
                            <p><span>{{ Accolade.Title }}</span> - <span>{{ Accolade.Author }}</span></p>
                            <p class="accolade">{{ Accolade.Content }}</p>
                        </div>
                    </b-collapse>
                    <hr v-if="getProduct.Accolades">
                </div>
            </div>
        </div>
        <div class="module-loading" v-else></div>
        <div class="event-rsvp" v-if="showRSVPForm">
            <div class="close" @click="showRSVPForm = false"><i class="fal fa-times"></i></div>
            <form @submit.prevent="reserveEvent">
                <h3>Event Reservation</h3>
                <label>Full Name</label>
                <input required type="text" v-model="eventRSVP.name">
                <label>Email</label>
                <input required type="email" v-model="eventRSVP.email">
                <label>Number of Attendees</label>
                <input required type="number" min="1" v-model="eventRSVP.attendees">
                <button type="submit" class="btn btn-light">Reserve</button>
            </form>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AddToCart from "./AddToCart";
import {Glide, GlideSlide} from 'vue-glide-js';
import moment from 'moment';

export default {
    name: "ProductDetails",
    components: {
        AddToCart,
        [Glide.name]: Glide,
        [GlideSlide.name]: GlideSlide
    },
    data() {
        return {
            showRSVPForm: false,
            eventRSVP: {
                name: '', email: '', attendees: 1
            },
            showShareLinks: false,
            IsAddedInWishList: false, //If it is the first time load, use the data from product, otherwise use the data in component
            firstLoad: true,
            selectedVariationID: null,
            selectedVariation: null
        }
    },
    watch: {
        selectedVariationID: function (val) {
            this.selectedVariation = this.getProduct.Variations.find(v => v.ID === val);
        }
    },
    filters: {
        date(val) {
            return val ? moment(val).format("MMMM Do YYYY, h:mm a") : "";
        }
    },
    computed: {
        ...mapGetters(['getProduct', 'getEventBooked']),
    },
    methods: {
        ...mapActions(['fetchProduct', 'makeRSVP', 'updateWishList']),
        showHarvestStats() {
            let product = this.getProduct,
                show = false;
            if (product.HarvestDate ||
                product.Brix ||
                product.HarvestAcidity ||
                product.HarvestPhValue ||
                product.Vineyard) {
                show = true;
            }
            return show;
        },
        showWineStats() {
            let product = this.getProduct,
                show = false;
            if (product.Alcohol ||
                product.ResidualSugar ||
                product.WineAcidity ||
                product.WinePhValue ||
                product.Blend) {
                show = true;
            }

            return show;
        },
        showStats() {
            return this.showHarvestStats() || this.showWineStats();
        },
        reserveEvent() {
            this.showRSVPForm = false;
            let data = new FormData();
            data.append('Name', this.eventRSVP.name);
            data.append('Email', this.eventRSVP.email);
            data.append('Attendees', this.eventRSVP.attendees);
            data.append('EventID', this.getProduct.ID);
            this.makeRSVP(data);
        },
        updateWish($link) {

            if (this.firstLoad == true) {
                this.firstLoad = false;
                this.IsAddedInWishList = this.getProduct.IsAddedInWishList;
            }

            this.updateWishList($link);
            this.IsAddedInWishList = !this.IsAddedInWishList;
        },
        productImpressionTracking() {
            /*if (this.$gtm.enabled()) {
                window.dataLayer?.push({ecommerce: null});
                window.dataLayer?.push({
                    'ecommerce': {
                        'detail': {
                            'actionField': {'list': 'Apparel Gallery'},
                            'products': [{
                                'name': this.getProduct.Title,
                                'id': this.getProduct.ID,
                                'price': this.getProduct.LocalisedPrice,
                                'category': this.getProduct.ProductType
                            }]
                        }
                    }
                });
            }*/
        },
        productAttribute($attr) {
            if (this.selectedVariation && this.selectedVariation[$attr]) {
                return this.selectedVariation[$attr];
            }
            return this.getProduct[$attr];
        },
        openNewTab(url) {
            window.open(url, '_blank');
        }
    },
    created() {
        this.fetchProduct();
    }
}
</script>
